// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Alert = theme => {
  return {
    MuiAlert: {
      variants: [{
        props: {
          severity: 'warning'
        },
        style: {
          backgroundColor: '#FFF9E5',
          border: '1px solid #8C6900',
          color: '#8C6900',
          '& .MuiAlert-icon': {
            color: '#8C6900'
          }
        }
      }, {
        props: {
          severity: 'success'
        },
        style: {
          backgroundColor: '#F0FDA7',
          border: '1px solid #314000',
          color: '#314000',
          '& .MuiAlert-icon': {
            color: '#314000'
          }
        }
      }, {
        props: {
          severity: 'error'
        },
        style: {
          backgroundColor: '#FDEEE9',
          border: '1px solid #80230D',
          color: '#80230D',
          '& .MuiAlert-icon': {
            color: '#80230D'
          }
        }
      }]
    }
  };
};

export { Alert };
